import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function ProfessionsClassificationIcon({ className }: IconProps) {
  return (
    <svg
      width="99"
      height="99"
      viewBox="0 0 99 99"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2051)">
        <path
          d="M63.9188 78.3071H27.9023V92.6956H63.9188V78.3071Z"
          fill="#EAEDF8"
        />
        <path
          d="M86.4214 80.9917H5.39945C2.41316 80.9917 0 78.5786 0 75.5923V18.9131C0 15.9268 2.41316 13.5137 5.39945 13.5137H86.3912C89.3775 13.5137 91.7907 15.9268 91.7907 18.9131V75.6225C91.7907 78.6087 89.3775 81.0219 86.3912 81.0219"
          fill="#EAEDF8"
        />
        <path
          d="M78.7593 98.9998H13.0609C11.3114 98.9998 9.92383 97.5821 9.92383 95.8627C9.92383 94.1433 11.3416 92.7256 13.0609 92.7256H78.7593C80.5088 92.7256 81.8964 94.1433 81.8964 95.8627C81.8964 97.5821 80.4787 98.9998 78.7593 98.9998Z"
          fill="#EAEDF8"
        />
        <path
          d="M82.3491 74.2649H9.44137C7.96331 74.2649 6.72656 73.0583 6.72656 71.5803V22.955C6.72656 21.477 7.93314 20.2402 9.44137 20.2402H82.3491C83.8271 20.2402 85.0337 21.4468 85.0337 22.955V71.5501C85.0337 73.0282 83.8271 74.2348 82.3491 74.2348"
          fill="white"
        />
        <path
          d="M53.0897 54.4468C51.0385 55.8343 48.565 56.6488 45.9106 56.6488C43.2561 56.6488 40.7826 55.8343 38.7314 54.4468C33.6939 56.8599 30.044 61.6259 29.2899 67.3572C29.1391 68.5035 30.044 69.529 31.2204 69.529H60.6308C61.8073 69.529 62.7122 68.5035 62.5614 67.3572C61.8073 61.6259 58.1272 56.8599 53.1199 54.4468H53.0897Z"
          fill="#00416B"
        />
        <path
          d="M54.93 43.7384C54.93 48.7156 50.8879 52.7576 45.9108 52.7576C40.9337 52.7576 36.8916 48.7156 36.8916 43.7384C36.8916 38.7613 40.9337 34.7192 45.9108 34.7192C50.8879 34.7192 54.93 38.7613 54.93 43.7384Z"
          fill="#00416B"
        />
        <path
          d="M29.2596 45.4578H9.44148C7.96342 45.4578 6.75684 44.2512 6.75684 42.743V22.955C6.75684 21.477 7.96342 20.2402 9.44148 20.2402H29.2596C30.7376 20.2402 31.9442 21.4468 31.9442 22.955V42.743C31.9442 44.221 30.7376 45.4578 29.2596 45.4578Z"
          fill="#DFE2E9"
        />
        <path
          d="M23.0153 34.8398C21.9596 35.5336 20.7228 35.9559 19.3654 35.9559C18.008 35.9559 16.7411 35.5336 15.7155 34.8398C13.1515 36.0766 11.2813 38.4898 10.8892 41.4157C10.8289 42.019 11.2813 42.5318 11.8846 42.5318H26.8764C27.4797 42.5318 27.9321 42.019 27.8718 41.4157C27.4797 38.4898 25.6095 36.0464 23.0455 34.8398H23.0153Z"
          fill="#00C4B3"
        />
        <path
          d="M23.9511 29.35C23.9511 31.8839 21.8999 33.9652 19.3359 33.9652C16.7719 33.9652 14.7207 31.914 14.7207 29.35C14.7207 26.7861 16.7719 24.7349 19.3359 24.7349C21.8999 24.7349 23.9511 26.7861 23.9511 29.35Z"
          fill="#00C4B3"
        />
        <path
          d="M50.405 13.5136C50.405 15.9871 48.384 18.0081 45.9105 18.0081C43.437 18.0081 41.416 15.9871 41.416 13.5136C41.416 11.0401 43.437 9.01904 45.9105 9.01904C48.384 9.01904 50.405 11.0401 50.405 13.5136Z"
          fill="#00416B"
        />
        <path
          d="M48.1428 13.5138C48.1428 14.7506 47.1474 15.7761 45.8805 15.7761C44.6136 15.7761 43.6182 14.7807 43.6182 13.5138C43.6182 12.2469 44.6136 11.2515 45.8805 11.2515C47.1474 11.2515 48.1428 12.2469 48.1428 13.5138Z"
          fill="#FBFCFE"
        />
        <path
          d="M66.0001 28.8071L60.6007 41.6572C60.4197 42.0795 60.8721 42.4717 61.2643 42.2303L82.9224 28.8071H66.0001Z"
          fill="#DFE2E9"
        />
        <path
          d="M96.3153 32.3967H57.6142C56.1362 32.3967 54.8994 31.1901 54.8994 29.6819V2.71481C54.8994 1.20658 56.106 0 57.6142 0H96.3153C97.7934 0 99.0301 1.20658 99.0301 2.71481V29.7121C99.0301 31.1901 97.8235 32.4269 96.3153 32.4269"
          fill="#DFE2E9"
        />
        <path
          d="M91.8204 20.2405H75.1696C74.6869 20.2405 74.2646 19.8484 74.2646 19.3356C74.2646 18.8228 74.6568 18.4307 75.1696 18.4307H91.8204C92.303 18.4307 92.7253 18.8228 92.7253 19.3356C92.7253 19.8484 92.3332 20.2405 91.8204 20.2405Z"
          fill="#00416B"
        />
        <path
          d="M70.193 20.2405H62.0788C61.5961 20.2405 61.1738 19.8484 61.1738 19.3356C61.1738 18.8228 61.566 18.4307 62.0788 18.4307H70.193C70.6757 18.4307 71.098 18.8228 71.098 19.3356C71.098 19.8484 70.7058 20.2405 70.193 20.2405Z"
          fill="#00416B"
        />
        <path
          d="M80.5697 26.5447H62.109C61.6264 26.5447 61.2041 26.1526 61.2041 25.6398C61.2041 25.127 61.5962 24.7349 62.109 24.7349H80.5697C81.0524 24.7349 81.4747 25.127 81.4747 25.6398C81.4747 26.1526 81.0825 26.5447 80.5697 26.5447Z"
          fill="#00416B"
        />
        <path
          d="M91.8204 13.9358H83.2838C82.8012 13.9358 82.3789 13.5437 82.3789 13.0309C82.3789 12.5181 82.771 12.126 83.2838 12.126H91.8204C92.303 12.126 92.7253 12.5181 92.7253 13.0309C92.7253 13.5437 92.3332 13.9358 91.8204 13.9358Z"
          fill="#00416B"
        />
        <path
          d="M78.3074 13.9358H62.109C61.6264 13.9358 61.2041 13.5437 61.2041 13.0309C61.2041 12.5181 61.5962 12.126 62.109 12.126H78.3074C78.79 12.126 79.2123 12.5181 79.2123 13.0309C79.2123 13.5437 78.8202 13.9358 78.3074 13.9358Z"
          fill="#00416B"
        />
        <path
          d="M91.8204 7.66192H75.1696C74.6869 7.66192 74.2646 7.26978 74.2646 6.75699C74.2646 6.24419 74.6568 5.85205 75.1696 5.85205H91.8204C92.303 5.85205 92.7253 6.24419 92.7253 6.75699C92.7253 7.26978 92.3332 7.66192 91.8204 7.66192Z"
          fill="#00416B"
        />
        <path
          d="M70.193 7.66192H62.0788C61.5961 7.66192 61.1738 7.26978 61.1738 6.75699C61.1738 6.24419 61.566 5.85205 62.0788 5.85205H70.193C70.6757 5.85205 71.098 6.24419 71.098 6.75699C71.098 7.26978 70.7058 7.66192 70.193 7.66192Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2051">
          <rect width="99" height="99" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
